// extracted by mini-css-extract-plugin
module.exports = {"sessionCard":"styles_sessionCard__BgntW","toggleComponent":"styles_toggleComponent__21IuH","cardTitle":"styles_cardTitle__2Ey8j","collapse":"styles_collapse__3psln"};